const DATA_TEST_IDS = {
  securityConfirmEndOneDialog: 'profile__security_confirm-end-one-dialog',
  securityConfirmEndAllDialog: 'profile__security_confirm-end-all-dialog',
} as const;

export default DATA_TEST_IDS;
